import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { fadeInUpAnimation } from '../../@fury/animations/fade-in-up.animation';
import { LoginService } from './login.service';

@Component({
  selector: 'fury-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [fadeInUpAnimation]
})
export class LoginComponent implements OnInit {
  private loginService = inject(LoginService);
  form: UntypedFormGroup;

  inputType = 'password';
  visible = false;

  constructor(private router: Router,
              private fb: UntypedFormBuilder,
              private cd: ChangeDetectorRef,
              private snackbar: MatSnackBar
  ) {
  }

  ngOnInit() {
    localStorage.clear();
    this.form = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  async send() {
    if(this.form.valid){
      let loggedin = await this.loginService.login(this.form.value.email, this.form.value.password);
      if(!loggedin.isLoggedIn()){
        this.snackbar.open(loggedin.message, 'حسناً', {
          duration: 10000
        });
        return;
      }
      else{
        this.snackbar.open(loggedin.message, 'حسناً', {
          duration: 10000
        });
        this.router.navigate(['/']);
      }
    }
    else{
      this.snackbar.open('إسم المستخدم وكلمة المرور إحدهما خاطئ.', 'حسناً', {
        duration: 10000
      });
    }
  }

  toggleVisibility() {
    if (this.visible) {
      this.inputType = 'password';
      this.visible = false;
      this.cd.markForCheck();
    } else {
      this.inputType = 'text';
      this.visible = true;
      this.cd.markForCheck();
    }
  }
}
